export default "__VITE_ASSET__snHL24fE__"